import { render, staticRenderFns } from "./SearchV2.vue?vue&type=template&id=af3e5448&"
import script from "./SearchV2.vue?vue&type=script&lang=ts&"
export * from "./SearchV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports